module.exports = [{
      plugin: require('/Users/devhaus/Documents/Omar/Proyectos/balvanera_gatsby/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-PQD83W7","defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}}},
    },{
      plugin: require('/Users/devhaus/Documents/Omar/Proyectos/balvanera_gatsby/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/devhaus/Documents/Omar/Proyectos/balvanera_gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
